<div class="page-card-component">
  <div
    *ngIf="!isLoading"
    class="card page-card"
    [class.menu-open]="isPageMenuOpen"
    (click)="onCardClick($event, page)"
    (mouseover)="isHovered = true"
    (mouseleave)="isHovered = false"
  >
    <div class="card-body">
      <div class="info-container">
        <mat-chip
          title="Page Status: Draft"
          class="draft-status"
          *ngIf="showPageStatusIcon('Draft')"
          >D</mat-chip
        >
        <mat-chip
          title="Page Status: Waiting For Verification"
          class="waiting-for-verification-status"
          *ngIf="showPageStatusIcon('WaitingForVerification')"
          >W</mat-chip
        >
        <mat-chip
          title="Page Status: Verified"
          class="verified-status"
          *ngIf="showPageStatusIcon('Verified')"
          >V</mat-chip
        >
        <mat-chip
          title="Page Status: Published"
          class="published-status"
          *ngIf="showPageStatusIcon('Published')"
          >P</mat-chip
        >
        <mat-chip
          title="Page Status: Retired"
          class="retired-status"
          *ngIf="showPageStatusIcon('Retired')"
          >R</mat-chip
        >
      </div>
      <div class="hover-overlay" *ngIf="isHovered"></div>
      <button
        *ngIf="canEdit && isHovered"
        class="edit-button"
        (click)="onEdit($event, page)"
        title="Edit"
      >
        Edit
      </button>
      <div
        class="col-sm-5 page-card-title-container page-type-label"
        style="text-align: end; display: flex"
        [style.backgroundColor]="getBackgroundColor(page.Type)"
      >
        <span
          class="page-card-title"
          [title]="pageTypeMap[page.Type - 1].label"
          >{{ pageTypeMap[page.Type - 1].label }}</span
        >
        <button
          class="page-menu-button"
          mat-icon-button
          [matMenuTriggerFor]="pageMenu"
          (menuOpened)="isPageMenuOpen = true"
          (menuClosed)="isPageMenuOpen = false"
          (click)="$event.stopPropagation()"
          aria-label="Page options"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col-sm-10 page-card-title-container">
          <span class="page-card-title" [title]="page.Title">{{
            page.Title
          }}</span>
        </div>
        <div
          class="col-sm-2 delete-icon text-center"
          *ngIf="canDelete"
          (click)="onDelete($event, page)"
          title="Delete"
        >
          <i class="bi bi-trash fs-6"></i>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading" class="card page-card loader">
    <div class="card-body">
      <div class="image-container"></div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col-sm-10"></div>
        <div class="col-sm-2"></div>
      </div>
    </div>
  </div>

  <mat-menu #pageMenu="matMenu">
    <button mat-menu-item class="page-menu-option" (click)="changePageType()">
      <mat-icon>swap_horiz</mat-icon>
      <span>Change Page Type</span>
    </button>
  </mat-menu>
</div>
